/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { useCallback, useEffect, useMemo, useState } from "react";
import { Link, useHistory } from "react-router-dom";
import { connect } from "react-redux";
import { getDatabase, ref, onValue } from "firebase/database";
import { Button, Dropdown, Modal, notification, Table, Tag } from "antd";
import Hotkeys from 'react-hot-keys';
import {
  CoffeeOutlined,
  LogoutOutlined,
  UserOutlined,
} from "@ant-design/icons";
import ClinicApi from "../../sdk/api/Clinics";
import UserApi from "../../sdk/api/User";
import "./styles.css";

const mapStateToProps = ({ user, clinics, insurances, dispatch }) => ({
  dispatch,
  user,
  clinics,
  insurances,
});

const developerIds = ["v1YF4orXH2hP8yuE9pjnpAMHdBm2", "CpxMsC93rZcbcKzC1Yh0d5oQm0D2"];

const Header = ({ user, insurances, dispatch }) => {

  const database = getDatabase();
  const [breakPoint, setBreakPoint] = useState();
  const [isMounted, setIsMounted] = useState(false);
  const [userRole, setUserRole] = useState(user.role);
  const [isModalVisible, setIsModalVisible] = useState(false);

  useEffect(() => {
    setIsMounted(true);

    return () => {
      setIsMounted(false);
    };
  }, [isMounted]);

  useEffect(() => {
    if (isMounted && user.role !== undefined) {
      setUserRole(user.role)
    }
  }, [isMounted, user])

  useEffect(() => {
    const userRef = ref(database, 'users/' + user.id);

    onValue(userRef, (snapshot) => {
      const updatedUserData = snapshot.val();
      
      if (updatedUserData.role !== user.role) {

        notification.warning({
          message: 'Important update',
          description: 'the web application will reload in a few seconds.',
          interval: 10
        });

        const interval = setInterval(() => {
          window.location.reload(true);
        }, 5000);

        return () => {
          clearInterval(interval);
        }
      }
    });
  }, [user, database])
  
  const breakPoints = useMemo(() =>  {
    return {
      mobile: "(max-width:600px)",
      tablet: "(min-width:600px) and (max-width:992px)",
      laptop: "(min-width:993px) and (max-width:1023px)",
      desktop: "(min-width:1024px)",
    }
  }, []);

  useEffect(() => {
    breakPointObserver(breakPoints, setBreakPoint);
    return () => {
      setIsMounted(false);
    };
  }, [breakPoint, breakPoints]);

  useEffect(() => {
    if (isMounted) {
      insurances.groupNumbers.map(item => {
        if (item.submitTimestamp === undefined) {
          return dispatch({
            type: "insurance/DELETE_RESPONSE",
            payload: item.groupNumberID,
          });
        }

        return false;
      });
    }
  }, []);

  const onKeyDown = (keyName, e, handle) => {
    e.preventDefault();
    setIsModalVisible(true);
  }

  const onClose = () => {
    setIsModalVisible(false);
  }

  const columns = [
    {
      title: 'Page',
      dataIndex: 'page',
      key: 'page',
    },
    {
      title: 'Shortcut key',
      key: 'shortcut',
      dataIndex: 'shortcut',
      render: (_, { keys }) => (
        <>
          {keys.map(tag => {
            let color = 'geekblue';
            if (tag === 'Shift') {
              color = 'lightgray';
            } else if (tag === 'S') {
              color = 'green';
            } else if (tag === 'P') {
              color = 'purple';
            } else if (tag === '/') {
              color = 'volcano';
            } 

            return (
              <Tag color={color} key={tag}>
                {tag.toUpperCase()}
              </Tag>
            );
          })}
        </>
      ),
    },
    {
      title: 'Description',
      dataIndex: 'description',
      key: 'description',
    },
  ];

  const data = [
    {
      key: '1',
      page: 'Patient Page',
      keys: ['Shift', 'S'],
      description: 'Save the displayed Patient PDF to the patient\'s folder in the web app.',
    },
    {
      key: '2',
      page: 'Patient Page',
      keys: ['Shift', 'P'],
      description: 'Save the displayed Patient PDF to your local folder.',
    },
    {
      key: '3',
      page: 'Patient Page',
      keys: ['Shift', 'D'],
      description: 'Duplicate the current patient record.',
    },
    {
      key: '4',
      page: 'Edit Patient Page',
      keys: ['Shift', 'D'],
      description: 'Duplicate the current patient record.',
    },
    {
      key: '5',
      page: 'Edit Patient Page',
      keys: ['Shift', 'P'],
      description: 'Generate a Patient PDF that saves in your local folder.',
    },
    {
      key: '6',
      page: 'Edit Group Number Page',
      keys: ['Shift', 'D'],
      description: 'Duplicate the current group number record.',
    },
    {
      key: '7',
      page: 'Edit Group Number Page',
      keys: ['Shift', 'P'],
      description: 'Generate a Group Number PDF that saves in your local folder.',
    },
    {
      key: '8',
      page: 'Any Page',
      keys: ['Shift', '/'],
      description: 'Open the modal with a list of all available shortcuts.',
    },
  ];

  return (
    <div
      style={
        // breakPoint === "mobile" || breakPoint === "tablet" ?
        //   { display: "grid", gridTemplateColumns: "2fr 8fr 2fr", alignItems: "center", margin: "0 10px 0 10px"}
        // :
        //   { display: "flex", justifyContent: "space-between", alignItems: "center",}
        {
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }
      }
    >
      {(breakPoint === "mobile" || breakPoint === "tablet") && <NavBarButton userRole={userRole} />}
      {(breakPoint === "laptop" || breakPoint === "desktop") && <MenuItems userRole={userRole} />}

      {(breakPoint === "mobile" || breakPoint === "tablet") && (
        <AccountSettingsMini user={user} dispatch={dispatch} />
      )}
      {(breakPoint === "laptop" || breakPoint === "desktop") && (
        <AccountSettings user={user} dispatch={dispatch} />
      )}

      <Modal
        centered
        open={isModalVisible}
        footer={null}
        closable={false}
        keyboard={false}
        width={850}
      >
        <div className='row p-2'>
          <h3>Shortcut Keys</h3>
          <Table columns={columns} dataSource={data} pagination={false} />
          <div className="mt-3">
            <Button
              htmlType='submit'
              onClick={onClose}
              shape='round'
              style={{ color: "gray", padding: '0 30px' }}
            >
              Close
            </Button>
          </div>
        </div>
      </Modal>

      <Hotkeys
        keyName="shift+/" 
        onKeyDown={onKeyDown}
      />
    </div>
  );
};

const MenuItems = ({userRole}) => {

  const getFontWeight = useCallback((page) => {
    
    if (document.URL.includes(page)) {
      return {
        color: 'black',
        fontSize: 16,
        fontWeight: 600
      }
    }

    return {
      color: 'black',
      fontSize: 16
    }
  }, [])

  return (
    <>
      {
        userRole === 'admin' ? (
          <div
            style={{
              display: 'grid',
              gridAutoFlow: 'column'
            }}
          >
            <Button type='link'>
              <Link 
                to='/forms'
                className="align-middle" 
                style={getFontWeight('/forms')}
              >
                Forms
              </Link>
            </Button>

            <Button type='link'>
              <Link 
                to='/clinics'
                className="align-middle" 
                style={getFontWeight('/clinics')}
              >
                Clinics
              </Link>
            </Button>

            <Button type='link'>
              <Link 
                to='/insurance'
                className="align-middle" 
                style={getFontWeight('/insurance')}
              >
                Insurances
              </Link>
            </Button>

            <Button type='link'>
              <Link 
                to='/accounts'
                className="align-middle" 
                style={getFontWeight('/accounts')}
              >
                Accounts
              </Link>
            </Button>

            <Button type='link'>
              <Link 
                to='/tools'
                className="align-middle" 
                style={getFontWeight('/tools')}
              >
                Tools
              </Link>
            </Button>
          </div>
        ) : (
          <div
            style={{
              display: 'grid',
              gridAutoFlow: 'column'
            }}
          >
            <Button type='link'>
              <Link 
                to='/clinics'
                className="align-middle" 
                style={getFontWeight('/clinics')}
              >
                Clinics
              </Link>
            </Button>

            <Button type='link'>
              <Link 
                to='/insurance'
                className="align-middle" 
                style={getFontWeight('/insurance')}
              >
                Insurances
              </Link>
            </Button>

            <Button type='link'>
              <Link 
                to='/tools'
                className="align-middle" 
                style={getFontWeight('/tools')}
              >
                Tools
              </Link>
            </Button>
          </div>
        )
      }
    </>
  )
};

const NavBarButton = ({userRole}) => {
  return (
    <div
      className='dropdown'
      style={{
        display: "grid",
        alignItems: "center",
        justifyItems: "center",
        width: "20px",
        // height: "20px",
        backgroundColor: "white",
        border: "none",
        padding: 0,
      }}
    >
      <div
        style={{ color: "rgba(0, 0, 0, 0.55)" }}
        role='button'
        id='dropdownMenuLink'
        data-bs-toggle='dropdown'
        aria-expanded='false'
      >
        <svg
          xmlns='http://www.w3.org/2000/svg'
          width='20'
          height='20'
          fill='currentColor'
          className='bi bi-list'
          viewBox='0 0 16 16'
        >
          <path
            fillRule='evenodd'
            d='M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z'
          />
        </svg>
      </div>

      <div className='dropdown-menu' aria-labelledby='dropdownMenuLink'>
        {
          userRole === 'admin' && <Link className='dropdown-item' to='/'>
            Forms
          </Link>
        }
        
        <Link className='dropdown-item' to='/clinics'>
          Clinics
        </Link>
        <Link className='dropdown-item' to='/insurance'>
          Insurance
        </Link>

        {
          userRole === 'admin' && (
            <Link className='dropdown-item' to='/accounts'>
              Accounts
            </Link>
          )
        }
        
        <Link className='dropdown-item' to='/tools'>
          Tools
        </Link>
      </div>
    </div>
  );
};

const AccountSettingsMini = ({ user, dispatch }) => {

  const history = useHistory();

  const onClick = () => {
    dispatch({
      type: "user/LOGOUT",
    });

    dispatch({
      type: "user/SET_STATE",
      payload: {
        id: '',
        name: '',
        email: '',
        avatar: '',
        role: '',
        username: '',
        authorized: false,
        users: []
      },
    });
  };

  const dropdownItems = [
    {
      label: (
        <div className="d-flex align-items-center">
          <UserOutlined /> <Link to='/profile' style={{ marginLeft: 10, color: 'inherit' }}>Profile</Link>
        </div>
      ),
      key: "0",
    },
    { type: "divider" },
    {
      label: (
        <div onClick={onClick} className="d-flex align-items-center">
          <LogoutOutlined /> <span style={{ marginLeft: 10, color: 'inherit' }}>Logout</span>
        </div>
      ),
      key: "3",
    }
  ]

  if (developerIds.includes(user.id)) {
    dropdownItems.push({
      label: (
        <div 
          onClick={() => history.push("/developer/settings")} 
          className="d-flex align-items-center"
        >
          <CoffeeOutlined /> <span style={{ color: 'inherit', marginLeft: 10 }}>Developer settings</span>
        </div>
      ),
      key: "4",
    })
  }

  return (
    <div className='row'>
      <div className='col align-self-end' style={{ textAlign: "right" }}>
        <Dropdown 
          trigger={["click"]}
          menu={{ 
            items: dropdownItems
          }}
        >
          <Button size='large' shape='round'>
            <UserOutlined />
          </Button>
        </Dropdown>
      </div>
    </div>
  );
};

const AccountSettings = ({ user, dispatch }) => {

  const history = useHistory();
  const [isMounted, setIsMounted] = useState(false);
  const [clinicDropdownItems, setClinicDropdownItems] = useState([]);
  const [clinic, setClinic] = useState({});
  const [isSavingPreferredClinic, setIsSavingPreferredClinic] = useState(false);

  useEffect(() => {
    setIsMounted(true);

    return () => {
      setIsMounted(false);
    };
  }, [isMounted]);

  const onSelectClinic = useCallback(async (selectedClinic) => {
    let previousClinic;

    // Optimistically update the UI
    setClinic((prev) => {
      previousClinic = prev;
      return {
        key: selectedClinic.clinicId,
        label: (
          <div className="d-flex align-items-center">
            {selectedClinic.clinicName}
          </div>
        ),
        clinicname: selectedClinic.clinicName,
      };
    });

    setIsSavingPreferredClinic(true);

    try {
      // Axios throws on 4xx/5xx
      await UserApi.EditPreferredClinic(user.id, selectedClinic.clinicId);

      dispatch({
        type: "user/EDIT_PREFERRED_CLINIC",
        payload: {
          preferredClinic: selectedClinic.clinicId
        },
      });
    } catch (error) {
      setClinic(previousClinic); // Rollback
    } finally {
      setIsSavingPreferredClinic(false);
    }
  }, [user.id, dispatch]);

  // Get clinic list
  useEffect(() => {
    const fetchClinicList = async () => {
      const clinicList = await ClinicApi.GetClinicList();

      if (clinicList) {
        const createDropdownItems = clinicList.clinics
          .sort((a, b) => a.clinicName.localeCompare(b.clinicName))
          .map(clinic => {
            return {
              key: clinic.clinicId,
              label: (
                <div className="d-flex align-items-center" onClick={() => onSelectClinic(clinic)}>
                    {clinic.clinicName}
                </div>
              ),
              clinicname: clinic.clinicName,
            }
          });
        setClinicDropdownItems(createDropdownItems);
      }
    };

    if (isMounted) fetchClinicList();
  }, [isMounted, onSelectClinic]);

  useEffect(() => {
    const getPreferredClinic = async () => {
      const getPreferredClinic = await UserApi.GetPreferredClinic(user.id);

      if (getPreferredClinic) {
        const preferredClinic = clinicDropdownItems.find(item => {
          return item.key === getPreferredClinic?.findPreferredClinic?.preferredClinicId;
        });
        setClinic(preferredClinic);
        dispatch({
          type: "user/EDIT_PREFERRED_CLINIC",
          payload: {
            preferredClinic: preferredClinic?.key ? preferredClinic.key : '',
          },
        });
      }
    }

    if (isMounted) getPreferredClinic();
  }, [isMounted, user.id, clinicDropdownItems, dispatch]);

  const onClick = () => {
    dispatch({
      type: "user/LOGOUT",
    });

    dispatch({
      type: "user/SET_STATE",
      payload: {
        id: '',
        name: '',
        email: '',
        avatar: '',
        role: '',
        username: '',
        authorized: false,
        users: []
      },
    });
  };

  const userDropdownItems = [
    {
      label: (
        <div className="d-flex align-items-center">
          <UserOutlined /> <Link to='/profile' style={{ color: 'inherit', marginLeft: 10 }}>Profile</Link>
        </div>
      ),
      key: "0",
    },
    { type: "divider" },
    {
      label: (
        <div onClick={onClick} className="d-flex align-items-center">
          <LogoutOutlined /> <span style={{ color: 'inherit', marginLeft: 10 }}>Logout</span>
        </div>
      ),
      key: "3",
    },
  ];

  if (developerIds.includes(user.id)) {
    userDropdownItems.push({
      label: (
        <div 
          onClick={() => history.push("/developer/settings")} 
          className="d-flex align-items-center"
        >
          <CoffeeOutlined /> <span style={{ color: 'inherit', marginLeft: 10 }}>Developer settings</span>
        </div>
      ),
      key: "4",
    })
  }

  return (
    <div className='row'>
      <div className='col align-self-end'>
        <Dropdown
          className="mx-1"
          trigger={["click"]}
          menu={{
            items: clinicDropdownItems
          }}
          loading={isSavingPreferredClinic}
        >
          <Button 
            size='large'
            shape="round"
          >
            {clinic?.clinicname != null ? clinic.clinicname : "Select a dental clinic"}
            <span className="material-symbols-outlined align-middle mx-1">
              dentistry
            </span>
          </Button>
        </Dropdown>

        <Dropdown
          className="mx-1"
          trigger={["click"]}
          menu={{
            items: userDropdownItems
          }}
        >
          <Button size='large' shape="round">
            <span className='align-middle'>{user.fullName}</span>{" "}
            <UserOutlined className='align-middle' />
          </Button>
        </Dropdown>
      </div>
    </div>
  );
};

function matchMediaQuery(breakPoints, setBreakPoint) {
  for (var key of Object.keys(breakPoints)) {
    if (window.matchMedia(`${breakPoints[key]}`).matches) {
      setBreakPoint(key);
    }
  }
}

function breakPointObserver(breakPoints, setBreakPoint) {
  matchMediaQuery(breakPoints, setBreakPoint);

  window.addEventListener("resize", () => {
    matchMediaQuery(breakPoints, setBreakPoint);
  });
}

export default connect(mapStateToProps)(Header);
